function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import $ from 'jquery';
import WDHCarouselTimer from './wdh-carousel-timer';
var _window = window,
    DGS = _window.DGS;
var IMAGE_LOADED = 'imageLoaded';
/**
 * WDHCarouselStack is a part of the WDHCarousel component.  WDHCarousel is responsible for
 * encapsulating the functionality of each group of components and separating the interval timers and events.
 * @author JTTO
 * @memberOf module:wdh-carousel
 */

var WDHCarouselStack = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {jQuery} slides - the group of components that will be grouped together in this instance of Carousel.
   */
  function WDHCarouselStack(slides) {
    _classCallCheck(this, WDHCarouselStack);

    /**
     * @private
     * @type {string}
     */
    this.wrapperClass = 'carousel';
    /**
     * @private
     * @type {string}
     */

    this.slidableClass = 'carousel-slidable';
    /**
     * class name to determine if a whole slide should be clickable
     * @private
     * @type {string}
     */

    this.makeSlideClickableClass = 'make-slide-clickable';
    /**
     * @private
     * @type {jQuery}
     */

    this.slides = slides;
    /**
     * @private
     * @type {jQuery} [null]
     */

    this.tabs = null;
    /**
     * @private
     * @type {number}
     */

    this.currentIndex = 0;
    /**
     * @private
     * @type {jQuery} [null]
     */

    this.arrowLeft = null;
    /**
     * @private
     * @type {jQuery} [null]
     */

    this.arrowRight = null;
    /**
     * @private
     * @type {jQuery} [null]
     */

    this.spinner = null;
    /**
     * @type {Object} options - Options for the class
     * @type {boolean} options.slideOnMobile - whether the component should be displayed as a carousel object on mobile.
     * @type {number} options.slideInterval - the length of time in milliseconds that the current slide of the carousel should display for before switching.
     * @type {boolean} options.editMode - value to determine if we are in SiteCore's  experience designer.
     */

    this.options = {
      slideOnMobile: false,
      slideInterval: 5000,
      editMode: false
    }; // mobile settings

    /**
     * @private
     * @type {boolean}
     */

    this.isMobileWidth = false;
    /**
     * @private
     * @type {number}
     */

    this.mobileMaxWidth = 767; // 767px
    // wrap slides in parent div so we can control it better

    this.slides.wrapAll("<div class=\"".concat(this.wrapperClass, "\" />"));
    /**
     * @private
     * @type {jQuery} - jquery object pointing to the container wrapping our carousel.
     */

    this.carouselWrapper = this.slides.parent();
    /**
     * object to track the initial position of a swipe gesture
     * @type {object} initialTouchPos - object containing the x, y coordinates of the first Touch position.
     * @type {object} initialTouchPos.x - x coordinate
     * @type {object} initialTouchPos.y - y coordinate
     */

    this.initialTouchPos = null;
    /**
     * used to track the last position of a swipe gesture
     * @type {object} lastTouchPos - object containing the x, y coordinates of the last Touch position.
     * @type {number} lastTouchPos.x - x coordinate
     * @type {number} lastTouchPos.y - y coordinate
     */

    this.lastTouchPos = null;
    /**
     * variable to hold the slide timer for this instance.
     * @type {WDHCarouselTimer}
     */

    this.timer = new WDHCarouselTimer();
  }
  /**
   * initializes the Carousel
   */


  _createClass(WDHCarouselStack, [{
    key: "init",
    value: function init() {
      var _this = this;

      // loop through slides and find out if they should be click-able (will only apply to intro-banners for now).
      // if so, wrap the banner in an anchor tag with the href from the intro-banner-link section.
      this.slides.each(function (index, elem) {
        var $this = $(elem);

        if ($this.hasClass(_this.makeSlideClickableClass)) {
          var link = $('.intro-banner-link a', $this).first();

          if (link.length === 1) {
            $this.find('.component-content').wrap("<a href=\"".concat(link.attr('href'), "\"> </a>"));
          }
        }
      });
      DGS.Event.getInstance().on(IMAGE_LOADED, function () {
        _this.resize();
      });
      this.run();
    }
    /**
     * run on every resize event.
     */

  }, {
    key: "resize",
    value: function resize() {
      this.run();
    }
    /**
     * run on every scroll event. Pause the slide timer if we scroll out of view.
     * @param scrollTop
     */

  }, {
    key: "onScroll",
    value: function onScroll(scrollTop) {
      var _this2 = this;

      var wrapperBottom = this.carouselWrapper.offset().top + (this.carouselWrapper.height() - 100);

      if (scrollTop > wrapperBottom && !this.timer.isPausedByScroll) {
        this.timer.pauseInterval();
        this.carouselWrapper.off('mouseleave'); // prevent the slideshow from resuming on mouseleave...

        this.timer.isPausedByScroll = true; // set this so that we don't unpause until the item comes back to view.
      } else if (scrollTop <= wrapperBottom && this.timer.isPausedByScroll) {
        this.timer.resumeInterval();
        this.carouselWrapper.on('mouseleave', function () {
          _this2.timer.resumeInterval();
        });
        this.timer.isPausedByScroll = false;
      }
    }
    /**
     * function to set our default options for the carousel
     * @param options {object}
     */

  }, {
    key: "setOptions",
    value: function setOptions(options) {
      if (_typeof(options) === 'object') {
        var tempOptions = Object.assign({}, this.options, options);
        this.options = tempOptions;
      }
    }
  }, {
    key: "run",
    value: function run() {
      var isReset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.isMobileWidth = window.matchMedia("(max-width: ".concat(this.mobileMaxWidth, "px)")).matches;
      var isMobile = this.isMobileWidth || this.slides.filter('.content-overflow').length; // add slide background color to match our slide navigation

      if (this.options.sliderTabsBelow) {
        var currSlide = this.slides.eq(this.currentIndex - 1);
        var bgColor = currSlide.css('background-color');
        this.carouselWrapper.css('background-color', bgColor);
      }

      if (isMobile && !this.options.slideOnMobile || this.options.editMode || isReset) {
        // stack the elements by cleaning up navigation items and resetting timers, etc.
        this.cleanupSliderNavigation();
      }

      if (!isMobile || this.options.slideOnMobile) {
        if (this.carouselWrapper.hasClass(this.slidableClass)) {
          // navigation already setup.
          this.setSliderHeights();
        } else {
          // Navigation doesn't exist, lets (re)build it.
          this.setupSliderNavigation();
          this.buildSlider();
        }
      }
    }
    /**
     * builds and places the navigation for the carousel.  I.e. Arrows and tabs
     */

  }, {
    key: "setupSliderNavigation",
    value: function setupSliderNavigation() {
      var _this3 = this;

      this.carouselWrapper.addClass(this.slidableClass);

      if (this.options.sliderTabsBelow) {
        this.carouselWrapper.addClass('slide-tab-navigation-below');
      }

      var showOnMobileClass = this.options.slideOnMobile ? 'show-on-mobile' : '';
      this.tabs = null;
      var tabsHtml = '<div class="slider-tabs"><div class="tabs-content">';
      var arrowLeft = "<div class=\"slider-arrow-left ".concat(showOnMobileClass, "\"></div>");
      var arrowRight = "<div class=\"slider-arrow-right ".concat(showOnMobileClass, "\"></div>");
      var spinner = '<div class="slider-spinner">Loading&#8230;</div>'; // build up slider tabs

      if (!this.carouselWrapper.find('.slider-tabs').length) {
        this.slides.each(function (index, elem) {
          var restrictedClass = _this3.options.hasRestrictedSlides && elem.classList.contains(_this3.options.restrictedSlideClass) ? 'restricted' : '';
          tabsHtml += "<div class=\"slider-tab ".concat(restrictedClass, "\"></div>");
        });
        tabsHtml += '</div></div>';
        this.carouselWrapper.append(tabsHtml);
        this.tabs = this.carouselWrapper.find('.slider-tabs');
      } // build up slider arrows


      if (!this.carouselWrapper.find('.slider-arrow-left').length) {
        this.carouselWrapper.append(arrowLeft);
        this.arrowLeft = this.carouselWrapper.find('.slider-arrow-left');
      }

      if (!this.carouselWrapper.find('slider-arrow-right').length) {
        this.carouselWrapper.append(arrowRight);
        this.arrowRight = this.carouselWrapper.find('.slider-arrow-right');
      } // spinner


      if (!this.carouselWrapper.find('slider-spinner').length) {
        this.carouselWrapper.append(spinner);
        this.spinner = this.carouselWrapper.find('.slider-spinner');
      }
    }
    /**
     * Adds the interactive functionality and timers to the previously created Navigation items.
     */

  }, {
    key: "buildSlider",
    value: function buildSlider() {
      var _this4 = this;

      this.slides.css('height', 'auto');
      this.arrowLeft.on('click touchstart', function (e) {
        e.preventDefault();

        _this4.timer.stopInterval();

        _this4.rotateSlides(true);
      });
      this.arrowRight.on('click touchstart', function (e) {
        e.preventDefault();

        _this4.timer.stopInterval();

        _this4.rotateSlides();
      });
      this.tabs.find('.slider-tab').on('click touchstart', function (event) {
        _this4.timer.stopInterval();

        var tabIndex = _this4.tabs.find('.slider-tab').index($(event.currentTarget));

        if (tabIndex + 1 < _this4.currentIndex) {
          _this4.currentIndex = tabIndex + 2;

          _this4.rotateSlides(true);
        } else {
          _this4.currentIndex = tabIndex;

          _this4.rotateSlides();
        }
      }); // Add Gesture Support for swipes

      if (window.PointerEvent) {
        // Add Pointer Event Listeners
        this.carouselWrapper.on('pointerdown', function (event) {
          _this4.handleGestureStart(event);
        });
        this.carouselWrapper.on('pointermove', function (event) {
          _this4.handleGestureMove(event);
        });
        this.carouselWrapper.on('pointerup', function (event) {
          _this4.handleGestureEnd(event);
        });
        this.carouselWrapper.on('pointercancel', function (event) {
          _this4.handleGestureEnd(event);
        });
      } else {
        // Add touch Listeners
        this.carouselWrapper.on('touchstart', function (event) {
          _this4.handleGestureStart(event);
        });
        this.carouselWrapper.on('touchmove', function (event) {
          _this4.handleGestureMove(event);
        });
        this.carouselWrapper.on('touchend', function (event) {
          _this4.handleGestureEnd(event);
        });
        this.carouselWrapper.on('touchcancel', function (event) {
          _this4.handleGestureEnd(event);
        }); // Add mouse Listener

        this.carouselWrapper.on('mousedown', function (event) {
          _this4.handleGestureStart(event);
        });
      }
      /* set up events to pause on hover */


      this.carouselWrapper.on('mouseenter', function () {
        // We want to pause the timer on hover.
        _this4.timer.pauseInterval();

        _this4.timer.isPausedByHover = true;
      });
      this.carouselWrapper.on('mouseleave', function () {
        _this4.timer.resumeInterval();

        _this4.timer.isPausedByHover = false;
      });
      this.setSliderHeights();
      this.currentIndex = 0;
      this.timer.stopInterval(); // start interval rotation

      this.timer.init(function () {
        _this4.rotateSlides();
      });
      this.timer.setInterval(this.options.slideInterval);
      this.timer.startInterval(); // mark first as active

      this.rotateSlides();
    }
    /**
     * removes the navigation items from the Carousel and clears timers.
     */

  }, {
    key: "cleanupSliderNavigation",
    value: function cleanupSliderNavigation() {
      this.carouselWrapper.find('.slider-tabs').remove();
      this.carouselWrapper.find('.slider-arrow-right').remove();
      this.carouselWrapper.find('.slider-arrow-left').remove();
      this.carouselWrapper.find('.slider-spinner').remove();
      this.carouselWrapper.css('height', 'auto');
      this.carouselWrapper.removeClass(this.slidableClass);
      this.timer.stopInterval();
      this.arrowRight = null;
      this.arrowLeft = null;
      this.spinner = null;
      this.tabs = null;
    }
    /**
     * rotates the slides.
     * @param {boolean} reverse - reverses the 'direction' that the slides will rotate.
     */

  }, {
    key: "rotateSlides",
    value: function rotateSlides() {
      var _this5 = this;

      var reverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (reverse) {
        // move backward
        if (this.currentIndex === 1) {
          this.currentIndex = this.slides.length;
        } else {
          this.currentIndex -= 1;
        }
      } else {
        // move forward
        if (this.currentIndex === this.slides.length) {
          this.currentIndex = 1;
        } else {
          this.currentIndex += 1;
        }
      }

      var currSlide = this.slides.eq(this.currentIndex - 1);

      if (this.options.hasRestrictedSlides && currSlide.hasClass(this.options.restrictedSlideClass)) {
        //skip the slide.
        this.rotateSlides(reverse);
        return;
      }

      this.slides.filter('.active-slide').removeClass('active-slide');
      this.slides.filter('.slide-backwards').removeClass('slide-backwards');
      this.tabs.find('.slider-tab.active-tab').removeClass('active-tab');
      currSlide.addClass('active-slide');

      if (reverse) {
        currSlide.addClass('slide-backwards');
      }

      this.tabs.find(".slider-tab:nth-child(".concat(this.currentIndex, ")")).addClass('active-tab'); // add slide background color to match our slide navigation

      if (this.options.sliderTabsBelow) {
        var bgColor = currSlide.css('background-color');
        this.carouselWrapper.css('background-color', bgColor);
        this.carouselWrapper.addClass('trans-bg');
      } // check to see if designer placed a new timer Interval in a style class .banner-timer
      // set this to be per slide


      if (currSlide.hasClass('carousel-timer')) {
        var classes = currSlide.attr('class').split(/\s+/);
        classes.forEach(function (elem) {
          var results = elem.match(/carousel-timer-([0-9]+)s/i);

          if (results) {
            _this5.timer.setInterval(results[1] * 1000);
          }
        });
      } else {
        // reset back to default timer.
        this.timer.setInterval(this.options.slideInterval);
      }

      if (!this.timer.isPausedByHover) {
        this.timer.startInterval();
      }
    }
    /**
     * Sets the height of the Carousel Wrapper to the largest height of all components in the stack.
     */

  }, {
    key: "setSliderHeights",
    value: function setSliderHeights() {
      var heights = this.slides.map(function (index, element) {
        return $(element).height();
      }).get(); //  set the tabs to show at 0.5 rem from the bottom of the image

      var rem = 0.5 * parseFloat(getComputedStyle(document.documentElement).fontSize);
      var tabsHeight = this.tabs.height() + 2 * rem; // 2rem allows for padding

      var maxHeight = Math.max.apply(null, heights);
      var carouselHeight = this.options.sliderTabsBelow ? maxHeight + tabsHeight : maxHeight;
      this.carouselWrapper.css('height', carouselHeight);
      this.spinner.hide();
      this.tabs.css('opacity', 1); // Push the arrows to be on the image while in a mobile view.

      var isMobile = this.isMobileWidth || this.slides.filter('.content-overflow').length;

      if (isMobile) {
        var imageHeight = this.carouselWrapper.find('.intro-banner-image').height();

        if (imageHeight > 0) {
          this.arrowLeft.css('top', imageHeight / 2);
          this.arrowRight.css('top', imageHeight / 2);
          this.tabs.css('top', imageHeight - tabsHeight);
          this.tabs.css('bottom', 'inherit');
        }
      } else {
        // reset our styles to be those from the stylesheet
        this.arrowLeft.css('top', '');
        this.arrowRight.css('top', '');
        this.tabs.css('bottom', '');
        this.tabs.css('top', '');
      }
    } // Gesture support

    /**
     * event handler to handle the start of a swipe event.
     * @param event
     */

  }, {
    key: "handleGestureStart",
    value: function handleGestureStart(event) {
      // grab originalEvent from jQuery if it exists.  Otherwise touch won't work.
      if (event.hasOwnProperty('originalEvent')) {
        event = event.originalEvent;
      }

      if (event.touches && event.touches.length > 1) {
        return;
      }

      this.timer.stopInterval();

      if (window.pointerEvent) {
        event.target.setPointerCapture(event.pointerId);
      } else {
        // add mouse listeners
        document.addEventListener('mousemove', this.handleGestureMove, true);
        document.addEventListener('mouseup', this.handleGestureEnd, true);
      }

      this.initialTouchPos = this.getGesturePointFromEvent(event);
    }
    /**
     * event handler to handle the move state of a swipe event.
     * @param event
     */

  }, {
    key: "handleGestureMove",
    value: function handleGestureMove(event) {
      // grab originalEvent from jQuery if it exists.  Otherwise touch won't work.
      if (event.hasOwnProperty('originalEvent')) {
        event = event.originalEvent;
      }

      if (!this.initialTouchPos) {
        return;
      }

      this.lastTouchPos = this.getGesturePointFromEvent(event);
    }
    /**
     * event handler to handle the end state of a swipe event.
     * @param event
     */

  }, {
    key: "handleGestureEnd",
    value: function handleGestureEnd(event) {
      // grab originalEvent from jQuery if it exists.  Otherwise touch won't work.
      if (event.hasOwnProperty('originalEvent')) {
        event = event.originalEvent;
      }

      event.preventDefault();

      if (event.touches && event.touches.length > 0) {
        return;
      } // remove event listeners


      if (window.pointerEvent) {
        event.target.releasePointerCapture(event.pointerId);
      } else {
        // Remove mouse listeners
        document.removeEventListener('mousemove', this.handleGestureMove, true);
        document.removeEventListener('mouseup', this.handleGestureEnd, true);
      }

      if (this.lastTouchPos === null) {
        // no movement detected. don't update slides.
        return;
      }

      var deltaX = this.initialTouchPos.x - this.lastTouchPos.x;
      var threshold = 10;

      if (deltaX >= threshold) {
        // swiped left
        this.rotateSlides();
      } else if (deltaX <= -threshold) {
        this.rotateSlides(true);
      }

      this.initialTouchPos = null;
      this.lastTouchPos = null;
    }
    /**
     * returns the x, y coordinates of a swipe event
     * @param event
     */

  }, {
    key: "getGesturePointFromEvent",
    value: function getGesturePointFromEvent(event) {
      // because we pass the var event from a method where we already checked for event.originalEvent, we don't need to here.
      var point = {};

      if (event.targetTouches) {
        point.x = event.targetTouches[0].clientX;
        point.y = event.targetTouches[0].clientY;
      } else {
        // Either mouse event or pointer event
        point.x = event.clientX;
        point.y = event.clientY;
      }

      return point;
    }
  }, {
    key: "getInstance",
    value: function getInstance() {
      return this.carouselWrapper;
    }
  }]);

  return WDHCarouselStack;
}();

export default WDHCarouselStack;